import { Agency } from 'core';
import {
  ColumnDefinition,
  sortableColumn,
  SortDescriptor
} from 'components/TableColumn/TableColumn';
import { Pagination } from 'core/pagination/Pagination';
import { TableChangeHandler } from 'components/common/Table/types';

export interface AgencyListModel {
  readonly nameColumn: ColumnDefinition;
  readonly currencyColumn: ColumnDefinition;
  readonly timeZoneColumn: ColumnDefinition;
  readonly statusColumn: ColumnDefinition | undefined;
  readonly editBtnsColumn: ColumnDefinition | undefined;

  readonly agencies: Array<Agency>;
  readonly pagination: Pagination;
  readonly onListChange?: TableChangeHandler<Agency>;
  readonly noDataDescription: string;
  readonly defaultSorts: SortDescriptor;
  readonly routePath: string;
}

export type AgencyListProps = {
  readonly model: AgencyListModel;
};

export enum AgencyListColumns {
  AGENCY_ID = 'id',
  VENDOR_NUMBER = 'vendorNumber',
  TIME_ZONE = 'timeZone',
  CURRENCY = 'currency',
  STATUS = 'status',
  EDITBTN = 'editBtn'
}

export class DefaultAgencyListModel implements AgencyListModel {
  agencies: Array<Agency>;
  pagination: Pagination;
  onListChange?: TableChangeHandler<Agency>;

  constructor(
    agencies: Array<Agency>,
    pagination: Pagination,
    onListChange?: TableChangeHandler<Agency>
  ) {
    this.agencies = agencies;
    this.pagination = pagination;
    this.onListChange = onListChange;
  }

  get noDataDescription(): string {
    return 'agencies.noDataAvailable';
  }

  get routePath(): string {
    return 'agencies';
  }

  get nameColumn(): ColumnDefinition {
    return sortableColumn(AgencyListColumns.AGENCY_ID, 'agencies.headers.name');
  }

  get timeZoneColumn(): ColumnDefinition {
    return sortableColumn(
      AgencyListColumns.TIME_ZONE,
      'agencies.headers.timeZone'
    );
  }

  get currencyColumn(): ColumnDefinition {
    return sortableColumn(
      AgencyListColumns.CURRENCY,
      'agencies.headers.currency'
    );
  }

  get statusColumn(): ColumnDefinition | undefined {
    return sortableColumn(
      AgencyListColumns.STATUS,
      'agencies.headers.status',
      false
    );
  }

  get editBtnsColumn(): ColumnDefinition | undefined {
    return sortableColumn(AgencyListColumns.EDITBTN, '', false);
  }

  get defaultSorts(): SortDescriptor {
    return [
      {
        dataField: 'id',
        order: 'asc'
      }
    ];
  }
}

export class RestaurantListModel extends DefaultAgencyListModel {
  get routePath(): string {
    return 'restaurants';
  }

  get noDataDescription(): string {
    return 'restaurants.noDataAvailable';
  }

  get nameColumn(): ColumnDefinition {
    return sortableColumn(
      AgencyListColumns.AGENCY_ID,
      'restaurants.headers.name'
    );
  }

  get statusColumn(): ColumnDefinition | undefined {
    return undefined;
  }

  get editBtnsColumn(): ColumnDefinition | undefined {
    return undefined;
  }
}
